import React, { ComponentPropsWithRef, FC, PropsWithChildren } from 'react';
import { AnimatedButton } from '@components/buttons/AnimatedButton/AnimatedButton.component';
import { TextWithArrow } from '@components/Text/TextWithArrow.component';
import { usePlcRouter } from '@utils/customHooks';
import classnames from 'classnames';
import styles from './WebviewBackButton.module.scss';

type Props = ComponentPropsWithRef<'button'>;

const WebviewBackButton: FC<PropsWithChildren<Props>> = ({ className }) => {
  const router = usePlcRouter();
  const rootClass = classnames(styles['webview-button'], className);

  return (
    <AnimatedButton className={rootClass} onClick={() => router.back()}>
      <TextWithArrow
        flavour="meteo-dark-green"
        i18nKey="common.webview.back.button"
        tag="p"
        variant="p"
        withArrow={false}
        withLeftArrow
      />
    </AnimatedButton>
  );
};

export { WebviewBackButton };
